import React, { useEffect, useState, useMemo } from 'react'
import '../stylesheets/DiaryDownload.scss'
import { Button, Dropdown } from 'components/UIElements'
import ParticipantFilter from './DiaryDataDownload/ParticipantFilter'
import DateFilter from './DiaryDataDownload/DateFilter'
import moment from 'moment'

const ParameterSelection = props => {
  return (
    <div className='diary-param-selection'>
      <section className='diary-filter-sec'>
        <h4 className='label-large'>Filter By</h4>
        <ParticipantFilter {...props} />
      </section>
      <section className='diary-date-sec'>
        <h4 className='label-large'>Time Range</h4>
        <span className='label-small'>SENT BETWEEN DATE</span>
        <DateFilter {...props} />
      </section>
    </div>
  )
}

const formatCheckedPtpsIntoArr = (checkedPtps = {}) => {
  const idArr = Object.keys(checkedPtps)
  const ptpRequestArr = []
  if (idArr.length === 0) return ptpRequestArr
  for (let i = 0; i < idArr.length; i++) {
    const checkedItem = checkedPtps[idArr[i]]

    /**
     * If the tree level of the checked item is 1, that means the study ID is still selected,
     * therefore we can make the data download request call with just the study ID without
     * passing any participant id params.
     */
    if (checkedItem.treeLevel === 1) break
    /**
     * When the tree level of the checked item is 3, this signifies a participant ID
     * as opposed to a site or study ID. We then push these IDs into the array with
     * which we will make the data download request.
     */ else if (checkedItem.treeLevel === 3) {
      ptpRequestArr.push(idArr[i])
    }
  }
  return ptpRequestArr
}

const AudioDataDownload = props => {
  const {
    checkedPtps,
    closeModal,
    audioDownloadLoading,
    downloadAudioData,
    fetchSelectionPtps,
    studyId,
    instruments,
  } = props

  const [date, setDate] = useState({ from: '', to: '', allDate: true })
  const [selectedInstrument, setSelectedInstrument] = useState(null)
  const [dateError, setDateError] = useState({
    from: {
      value: true,
      error: '',
    },
    to: {
      value: true,
      error: '',
    },
  })

  useEffect(() => {
    const today = moment().toDate()
    const monthAgo = moment()
      .subtract(1, 'months')
      .toDate()

    setDate({ from: monthAgo, to: today })
  }, [])

  const formattedInstruments = useMemo(() => {
    return instruments.map(instrument => {
      const actionCell = instrument.find(cell => cell.key === 'action')

      return {
        key: actionCell.id,
        text: `${actionCell.title} (${actionCell.id})`,
        version: actionCell.version || 1,
      }
    })
  }, [instruments])

  useEffect(() => {
    fetchSelectionPtps(studyId)
  }, [])

  const onSetDate = _date => {
    setDate(_date)
  }

  return (
    <div className='diary-download audio-download'>
      {/* <h3 className='headline'>Download audio data</h3>
      <div className='audio-modal-content'>
        <div>{MODAL_CONTENT_MAP.downloadAllAudioFilesSubtitle}</div>
        <div className='caption'>{MODAL_CONTENT_MAP.downloadAllAudioFilesCaption}</div>
      </div> */}
      <div className='instrument-id-selection'>
        <h4 className='label-large'>Instrument ID</h4>
        <Dropdown
          id='instrument-selection-dropdown'
          hasError={false}
          disabled={false}
          selected={selectedInstrument?.key}
          options={formattedInstruments}
          onSelect={newInstrument => {
            setSelectedInstrument(newInstrument)
          }}
          placeholder='Select Instrument ID'
        />
      </div>
      <div className='flexed start-aligned'>
        <ParameterSelection
          dateError={dateError}
          setDateError={setDateError}
          date={date}
          onSetDate={onSetDate}
          isLongFormat={false}
          {...props}
        />
      </div>
      <div className='buttons flexed end-justified'>
        <Button grey no-margin content='Close' onClick={() => closeModal()} />
        <Button
          no-margin
          content='Download Audio Data'
          disabled={
            audioDownloadLoading ||
            (!date.allDate && (dateError.from.value || dateError.to.value || !date.from || !date.to))
          }
          loading={audioDownloadLoading}
          onClick={() => {
            downloadAudioData({
              studyID: studyId,
              ptpIds: formatCheckedPtpsIntoArr(checkedPtps),
              instrumentId: selectedInstrument?.key,
              instrumentVersion: selectedInstrument?.version,
              from: date.from ? moment(date.from).format('YYYYMMDD') : undefined,
              to: date.to ? moment(date.to).format('YYYYMMDD') : undefined,
            })
          }}
        />
      </div>
    </div>
  )
}

export default AudioDataDownload
